/* eslint-disable */

export const groupsListEN = [
  { todo: 'transactions_empty', text: 'You have activities for your crystals. 💎'},
  { todo: 'my_groups', text: 'My groups' },
  { todo: 'open', text: 'Open' },
  { todo: 'Active', text: 'Active' },
  { todo: 'Expired', text: 'Expired' },
  { todo: 'approved', text: 'Approved' },
  { todo: 'approved_none', text: 'You haven`t been approved to any group yet. 😊' },
  { todo: 'no_groups', text: 'No new groups available right now. 😊' },
  { todo: 'add', text: 'Add' },
  { todo: 'pay', text: 'Pay' },
  { todo: 'pay_note_1', text: 'Creating a group costs 200 crystals' },
  { todo: 'pay_note_2', text: 'You don`t have enough crystals. Top up now!' },
  { todo: 'show_more', text: 'Show more' },
  { todo: 'pay_note_3', text: 'No one has requested to join your group yet. 😊' },
  { todo: 'general_info', text: 'General info' },
  { todo: 'general_info_other', text: 'Other category' },
  { todo: 'interests', text: 'Interests' },
  { todo: 'name', text: 'Name *' },
  { todo: 'description', text: 'Description' },
  { todo: 'link_to_tg', text: 'Link in Telegram *' },
  { todo: 'file_upload_new', text: 'Add picture' },
  { todo: 'file_upload_update', text: 'Change picture' },
  { todo: 'file_size', text: 'Max size' },
  { todo: 'file_types', text: 'Types' },
  { todo: 'pay_note_4', text: 'You don`t have any groups yet. Tap the button below to create one! 😊➕' },
  { todo: 'update', text: 'Update' },
  { todo: 'filters', text: 'Filters' },
  { todo: 'filters_desc', text: 'Select filters for more desired and accurate results.' },
  { todo: 'filters_local', text: 'By my location' },
  { todo: 'approved_users', text: 'Approved' },
  { todo: 'create_group_alert_time', text: 'End time'},
  { todo: 'create_group_alert', text: '⏱️ After creation, your listing will be active for 30 days. During this period, users can view it and like it. Once the 30 days expire, the listing is automatically moved to “Expired” and will no longer be visible to users.'}
];

export const groupsListRU = [
  { todo: 'transactions_empty', text: 'У вас нет активности  ваших кристаллов 💎'},
  { todo: 'my_groups', text: 'Мои группы' },
  { todo: 'open', text: 'Открыть' },
  { todo: 'Expired', text: 'Неактивные' },
  { todo: 'Active', text: 'Активные' },
  { todo: 'approved', text: 'Одобренные' },
  { todo: 'approved_none', text: 'Вас ещё не приняли ни в одну группу. 😊' },
  { todo: 'no_groups', text: 'В данный момент новых групп нет. 😊' },
  { todo: 'add', text: 'Добавить' },
  { todo: 'pay', text: 'Оплатить' },
  { todo: 'pay_note_1', text: 'Создание группы стоит 200 кристаллов.' },
  { todo: 'pay_note_2', text: 'У вас недостаточно кристаллов. Пополните запасы прямо сейчас!' },
  { todo: 'show_more', text: 'Показать еще' },
  { todo: 'pay_note_3', text: 'Пока никто не подал заявку на вступление в вашу группу. 😊' },
  { todo: 'general_info', text: 'Основная информация' },
  { todo: 'general_info_other', text: 'Разные категории' },
  { todo: 'interests', text: 'Теги' },
  { todo: 'name', text: 'Название *' },
  { todo: 'description', text: 'Описание' },
  { todo: 'link_to_tg', text: 'Ссылка в телеграм *' },
  { todo: 'file_upload_new', text: 'Добавить картинку' },
  { todo: 'file_upload_update', text: 'Изменить картинку' },
  { todo: 'file_size', text: 'Макс.Размер' },
  { todo: 'file_types', text: 'Типы' },
  { todo: 'pay_note_4', text: 'У вас пока нет групп. Нажмите кнопку ниже, чтобы создать её! 😊➕' },
  { todo: 'update', text: 'Обновить' },
  { todo: 'filters', text: 'Фильтры' },
  { todo: 'filters_desc', text: 'Выберите фильтры для получения более точных и желаемых результатов.' },
  { todo: 'filters_local', text: 'По моей локации' },
  { todo: 'approved_users', text: 'Добавлено' },  
  { todo: 'create_group_alert_time', text: 'Время окончания публикации'},
  { todo: 'create_group_alert', text: '⏱️ После создания ваше объявление будет активно 30 дней. В течение этого времени пользователи смогут видеть его лайкать. По истечении 30 дней объявление автоматически перемещается в разделе "Неактивные" и становится недоступным для просмотра другими пользователями.'}
];

export const interestsListEN = [
    { todo: 'Music', text: 'Music' },
    { todo: 'Sports', text: 'Sports' },
    { todo: 'Travel', text: 'Travel' },
    { todo: 'Movies', text: 'Movies' },
    { todo: 'Gaming', text: 'Gaming' },
    { todo: 'Reading', text: 'Reading' },
    { todo: 'Cooking', text: 'Cooking' },
    { todo: 'Dancing', text: 'Dancing' },
    { todo: 'Art', text: 'Art' },
    { todo: 'Technology', text: 'Technology' },
    { todo: 'Fitness', text: 'Fitness' },
    { todo: 'Photography', text: 'Photography' },
    { todo: 'Nature', text: 'Nature' },
    { todo: 'Fashion', text: 'Fashion' },
    { todo: 'Anime', text: 'Anime' },
    { todo: 'Hiking', text: 'Hiking' },
    { todo: 'Camping', text: 'Camping' },
    { todo: 'Running', text: 'Running' },
    { todo: 'Swimming', text: 'Swimming' },
    { todo: 'Yoga', text: 'Yoga' },
    { todo: 'Meditation', text: 'Meditation' },
    { todo: 'Astronomy', text: 'Astronomy' },
    { todo: 'Science', text: 'Science' },
    { todo: 'Psychology', text: 'Psychology' },
    { todo: 'Philosophy', text: 'Philosophy' },
    { todo: 'History', text: 'History' },
    { todo: 'Politics', text: 'Politics' },
    { todo: 'Languages', text: 'Languages' },
    { todo: 'Writing', text: 'Writing' },
    { todo: 'Poetry', text: 'Poetry' },
    { todo: 'Painting', text: 'Painting' },
    { todo: 'Drawing', text: 'Drawing' },
    { todo: 'DIY', text: 'DIY' },
    { todo: 'Gardening', text: 'Gardening' },
    { todo: 'Cars', text: 'Cars' },
    { todo: 'Motorcycles', text: 'Motorcycles' },
    { todo: 'Aviation', text: 'Aviation' },
    { todo: 'Space', text: 'Space' },
    { todo: 'Coding', text: 'Coding' },
    { todo: 'Startups', text: 'Startups' },
    { todo: 'Crypto', text: 'Crypto' },
    { todo: 'AI', text: 'AI' },
    { todo: 'Esports', text: 'Esports' },
    { todo: 'Board Games', text: 'Board Games' },
    { todo: 'Chess', text: 'Chess' },
    { todo: 'Volunteering', text: 'Volunteering' },
    { todo: 'Animals', text: 'Animals' },
    { todo: 'Dogs', text: 'Dogs' },
    { todo: 'Cats', text: 'Cats' },
    { todo: 'Coffee', text: 'Coffee' },
    { todo: 'Tea', text: 'Tea' },
    { todo: 'Food', text: 'Food' },
    { todo: 'Baking', text: 'Baking' },
    { todo: 'Wine', text: 'Wine' },
    { todo: 'Traveling', text: 'Traveling' },
    { todo: 'Beaches', text: 'Beaches' },
    { todo: 'Mountains', text: 'Mountains' },
    { todo: 'Urban Exploring', text: 'Urban Exploring' },
    { todo: 'Minimalism', text: 'Minimalism' },
    { todo: 'Sustainability', text: 'Sustainability' },
    { todo: 'Interior Design', text: 'Interior Design' },
    { todo: 'Makeup', text: 'Makeup' },
    { todo: 'Skincare', text: 'Skincare' },
    { todo: 'Tattoos', text: 'Tattoos' },
    { todo: 'Piercing', text: 'Piercing' },
    { todo: 'Festivals', text: 'Festivals' },
    { todo: 'Photography Film', text: 'Photography Film' },
    { todo: 'Vintage', text: 'Vintage' },
    { todo: 'Comics', text: 'Comics' },
    { todo: 'Manga', text: 'Manga' },
    { todo: 'KPop', text: 'KPop' },
    { todo: 'Movies Classic', text: 'Movies Classic' },
    { todo: 'Standup', text: 'Standup' },
    { todo: 'Podcasts', text: 'Podcasts' },
    { todo: 'Collecting', text: 'Collecting' },
    { todo: 'Traveling Solo', text: 'Traveling Solo' },
    { todo: 'Surfing', text: 'Surfing' },
    { todo: 'Snowboarding', text: 'Snowboarding' },
    { todo: 'Hiking Trails', text: 'Hiking Trails' },
    { todo: 'Nudes', text: 'Sensitive' },
];

export const interestsListRU = [
    { todo: 'Music', text: 'Музыка' },
    { todo: 'Sports', text: 'Спорт' },
    { todo: 'Travel', text: 'Путешествия' },
    { todo: 'Movies', text: 'Фильмы' },
    { todo: 'Gaming', text: 'Игры' },
    { todo: 'Reading', text: 'Чтение' },
    { todo: 'Cooking', text: 'Кулинария' },
    { todo: 'Dancing', text: 'Танцы' },
    { todo: 'Art', text: 'Искусство' },
    { todo: 'Technology', text: 'Технологии' },
    { todo: 'Fitness', text: 'Фитнес' },
    { todo: 'Photography', text: 'Фотография' },
    { todo: 'Nature', text: 'Природа' },
    { todo: 'Fashion', text: 'Мода' },
    { todo: 'Anime', text: 'Аниме' },
    { todo: 'Hiking', text: 'Походы' },
    { todo: 'Camping', text: 'Кемпинг' },
    { todo: 'Running', text: 'Бег' },
    { todo: 'Swimming', text: 'Плавание' },
    { todo: 'Yoga', text: 'Йога' },
    { todo: 'Meditation', text: 'Медитация' },
    { todo: 'Astronomy', text: 'Астрономия' },
    { todo: 'Science', text: 'Наука' },
    { todo: 'Psychology', text: 'Психология' },
    { todo: 'Philosophy', text: 'Философия' },
    { todo: 'History', text: 'История' },
    { todo: 'Politics', text: 'Политика' },
    { todo: 'Languages', text: 'Языки' },
    { todo: 'Writing', text: 'Письмо' },
    { todo: 'Poetry', text: 'Поэзия' },
    { todo: 'Painting', text: 'Живопись' },
    { todo: 'Drawing', text: 'Рисование' },
    { todo: 'DIY', text: 'Рукоделие' },
    { todo: 'Gardening', text: 'Садоводство' },
    { todo: 'Cars', text: 'Автомобили' },
    { todo: 'Motorcycles', text: 'Мотоциклы' },
    { todo: 'Aviation', text: 'Авиация' },
    { todo: 'Space', text: 'Космос' },
    { todo: 'Coding', text: 'Программирование' },
    { todo: 'Startups', text: 'Стартапы' },
    { todo: 'Crypto', text: 'Криптовалюта' },
    { todo: 'AI', text: 'Искусственный интеллект' },
    { todo: 'Esports', text: 'Киберспорт' },
    { todo: 'Board Games', text: 'Настольные игры' },
    { todo: 'Chess', text: 'Шахматы' },
    { todo: 'Volunteering', text: 'Волонтёрство' },
    { todo: 'Animals', text: 'Животные' },
    { todo: 'Dogs', text: 'Собаки' },
    { todo: 'Cats', text: 'Кошки' },
    { todo: 'Coffee', text: 'Кофе' },
    { todo: 'Tea', text: 'Чай' },
    { todo: 'Food', text: 'Еда' },
    { todo: 'Baking', text: 'Выпечка' },
    { todo: 'Wine', text: 'Вино' },
    { todo: 'Traveling', text: 'Путешествия' },
    { todo: 'Beaches', text: 'Пляжи' },
    { todo: 'Mountains', text: 'Горы' },
    { todo: 'Urban Exploring', text: 'Исследование городов' },
    { todo: 'Minimalism', text: 'Минимализм' },
    { todo: 'Sustainability', text: 'Экологичность' },
    { todo: 'Interior Design', text: 'Дизайн интерьера' },
    { todo: 'Makeup', text: 'Макияж' },
    { todo: 'Skincare', text: 'Уход за кожей' },
    { todo: 'Tattoos', text: 'Татуировки' },
    { todo: 'Piercing', text: 'Пирсинг' },
    { todo: 'Festivals', text: 'Фестивали' },
    { todo: 'Photography Film', text: 'Плёночная фотография' },
    { todo: 'Vintage', text: 'Винтаж' },
    { todo: 'Comics', text: 'Комиксы' },
    { todo: 'Manga', text: 'Манга' },
    { todo: 'KPop', text: 'K-pop' },
    { todo: 'Movies Classic', text: 'Классические фильмы' },
    { todo: 'Standup', text: 'Стендап' },
    { todo: 'Podcasts', text: 'Подкасты' },
    { todo: 'Collecting', text: 'Коллекционирование' },
    { todo: 'Traveling Solo', text: 'Путешествия в одиночку' },
    { todo: 'Surfing', text: 'Сёрфинг' },
    { todo: 'Snowboarding', text: 'Сноубординг' },
    { todo: 'Hiking Trails', text: 'Пешие маршруты' },
    { todo: 'Nudes', text: 'Деликатность' },
];

// Relationship status
export const relationshipOptions = [
  { todo: 'Single', text: 'Single' },
  { todo: 'In a relationship', text: 'In a relationship' },
  { todo: 'Married', text: 'Married' },
  { todo: 'It’s complicated', text: 'It’s complicated' },
  { todo: 'Open Relationship', text: 'Open Relationship' },
  { todo: 'Divorced', text: 'Divorced' },
  { todo: 'Widowed', text: 'Widowed' },
];

// Find for / connection type
export const findForOptions = [
  { todo: 'Serious relationship', text: 'Serious relationship' },
  { todo: 'Casual dating', text: 'Casual dating' },
  { todo: 'Friendship', text: 'Friendship' },
  { todo: 'Hangouts', text: 'Hangouts' },
  { todo: 'Networking', text: 'Networking' },
  { todo: 'Fun & No commitments', text: 'Fun & No commitments' },
];

// Пример для русского перевода
export const relationshipOptionsRu = [
  { todo: 'Single', text: 'Холост/Не замужем' },
  { todo: 'In a relationship', text: 'В отношениях' },
  { todo: 'Married', text: 'Женат/Замужем' },
  { todo: 'It’s complicated', text: 'Сложные отношения' },
  { todo: 'Open Relationship', text: 'Свободные отношения' },
  { todo: 'Divorced', text: 'Разведен/Разведена' },
  { todo: 'Widowed', text: 'Вдовец/Вдова' },
];

export const findForOptionsRu = [
  { todo: 'Serious relationship', text: 'Серьезные отношения' },
  { todo: 'Casual dating', text: 'Неформальные свидания' },
  { todo: 'Friendship', text: 'Дружба' },
  { todo: 'Hangouts', text: 'Тусовки/Встречи' },
  { todo: 'Networking', text: 'Нетворкинг' },
  { todo: 'Fun & No commitments', text: 'Развлечения без обязательств' },
];

export const serverTODO = [
  { todo: 'server_likes_already_unlocked', text: 'Your likes are already unlocked. Try refreshing the page or contacting support.'},
  { todo: 'server_enough_balance', text: 'You don`t have enough balance.'},
  { todo: 'user_not_found', text: 'User not found'},
  { todo: 'bad_session', text: 'Bad session'},
  { todo: 'user_not_found_after_update', text: 'User not found after update'},
  { todo: 'access_avatar', text: 'You don`t have access because you need to set your avatar'},
  { todo: 'access_hidden', text: 'Your profile is hidden, change your settings'},
  { todo: 'game_error', text: 'You cannot play a game!'} 
];

export const serverTODORu = [
  { todo: 'server_likes_already_unlocked', text: 'Твои лайки уже разблокированы. Попробуй обновить страницу или обратись в поддержку.' },
  { todo: 'server_enough_balance', text: 'У тебя недостаточно баланса.' },
  { todo: 'user_not_found', text: 'Пользователь не найден.' },
  { todo: 'bad_session', text: 'Неверная сессия.' },
  { todo: 'user_not_found_after_update', text: 'Пользователь не найден после обновления.' },
  { todo: 'access_avatar', text: 'У тебя нет доступа — установи аватарку.' },
  { todo: 'access_hidden', text: 'Твой профиль скрыт, измени настройки.' },
  { todo: 'game_error', text: 'Ты не можешь сыграть в игру!' },
];

export const listTodo = {
  ru: [
    ...groupsListRU,
  	...interestsListRU,
  	...relationshipOptionsRu,
  	...findForOptionsRu,
    ...serverTODORu,
  	{ todo: 'initData', text: 'Данные Telegram отсутствуют'},
  	{ todo: 'error', text: 'Ошибка'},
  	{ todo: 'error_other', text: 'Произошла неизвестная ошибка, попробуйте изменить поля или обновить страницу.'},
    { todo: 'auth_hello_header', text: 'Ищешь куда сходить? Хочешь найти единомышленников или интересный канал? ' },
    { todo: 'auth_hello_sub', text: 'Всё самое крутое собрано здесь — заходи, будет интересно! 🚀' },
    { todo: 'auth_hello_error_location', text: 'Геолокация отключена. Включи её в настройках приложения Telegram и попробуй снова.' },
    { todo: 'auth_hello_next_button', text: 'Начать поиск' },
    { todo: 'next', text: 'Дальше' },
    { todo: 'auth_hello_step2_header', text: '✨ Твоя история любви начинается здесь! ✨' },
  	{ todo: 'auth_hello_step2_sub', text: 'Прежде чем начать своё приключение, давай настроим твой профиль. 💕' },
  	{ todo: 'gender_male', text: 'Мужской' },
  	{ todo: 'gender_female', text: 'Женский' },
  	{ todo: 'gender_transgender', text: 'Трансгендер' },
  	{ todo: 'gender_other', text: 'Не определенный' },
    { todo: 'Male', text: 'Мужской' },
    { todo: 'Female', text: 'Женский' },
    { todo: 'Transgender', text: 'Трансгендер' },
    { todo: 'Unknown', text: 'Не определенный' },  
  	{ todo: 'placeholder_gender', text: 'Выбрать пол' },
  	{ todo: 'placeholder_gender_interest', text: 'Интересующий пол' },
  	{ todo: 'auth_hello_step3_header', text: '🎯 Что вызывает твой интерес?' },
  	{ todo: 'auth_hello_step3_sub', text: 'Выбери несколько тегов, которые описывают то, что тебе нравится! Это поможет найти людей с похожими интересами.' },
  	{ todo: 'auth_hello_step4_header', text: 'Определите Ваши связи 💫' },
  	{ todo: 'auth_hello_step4_sub', text: 'Дайте другим понять ваш семейный статус и чего вы ищете. Будь то любовь, дружба или просто хорошая компания – выберите то, что вам подходит!' },
  	{ todo: 'placeholder_relationship', text: 'Отношения' },
    { todo: 'placeholder_looking_for', text: 'Ищу ... ' },
    { todo: 'auth_hello_step5_header', text: '🚀 Твоя биография, твоя история' },
  	{ todo: 'auth_hello_step5_sub', text: 'Напиши о себе в одном-двух предложениях. Будь простым, будь настоящим.' },
  	{ todo: 'bio', text: 'Биография' },
  	{ todo: 'auth_hello_step6_header', text: 'Давай узнаем тебя! 🎭' },
    { todo: 'auth_hello_step6_sub', text: 'Твоя дата рождения помогает другим найти с тобой контакт. Будь собой и пусть путешествие начнется!' },
    { todo: 'auth_hello_step6_sub_sub', text: 'Возраст имеет значение для идеальной пары!' },
    { todo: 'day', text: 'День' },
    { todo: 'month', text: 'Месяц' },
    { todo: 'year', text: 'Год' },
  	{ todo: 'auth_hello_step7_header', text: '🎉 Все готово! Давай создадим твой профиль!' },
  	{ todo: 'auth_hello_step7_btn', text: 'К профилю' },
  	{ todo: 'spin_wheel_header', text: 'Крути колесо каждые 12 часов 🎡, пополняй баланс и выигрывай дополнительные кристаллы ✨!' },
  	{ todo: 'spin_wheel_btn', text: 'Крутить колесо' },
  	{ todo: 'spin_wheel_win_1', text: 'Ты выиграл' },
  	{ todo: 'spin_wheel_win_2', text: 'кристаллов!' },
  	{ todo: 'spin_wheel_win_text', text: 'Возвращайся через 12 часов и попробуй удачу снова — возможно, в следующий раз тебе повезёт 🎰' },
  	{ todo: 'spin_wheel_win_claim_1', text: 'Забрать' },
  	{ todo: 'spin_wheel_win_claim_3', text: 'кристалл' },
  	{ todo: 'spin_wheel_win_time_1', text: 'Возвращайся' },
  	{ todo: 'spin_wheel_win_time_2', text: 'и попробуй удачу снова — может, в следующий раз сорвёшь джекпот! 😎' },
  	{ todo: 'spin_wheel_ok', text: 'Хорошо, спасибо!' },
  	{ todo: 'spin_wheel_title', text: 'Вы не можете играть в игру!' },
    { todo: 'global_search', text: 'Шире поиск'},
    { todo: 'Profile', text: 'Профиль'},
    { todo: 'Balance', text: 'Баланс'},
    { todo: 'Settings', text: 'Настройки'},
    { todo: 'balance', text: 'Баланс кристаллов' },
  	{ todo: 'balance_top_up', text: 'Пополнить' },
  	{ todo: 'balance_activity', text: 'Последняя активность' },
  	{ todo: 'balance_header', text: '🚀 Усиль своё социальное влияние с помощью силы токенов!' },
  	{ todo: 'balance_text', text: 'Все премиум-функции всегда доступны, чтобы улучшить твой опыт! Просто используй баланс токенов, чтобы активировать опции — создавать больше групп, увеличивать ежедневные лайки. Никакой подписки не нужно!' },
  	{ todo: 'Balance Refill', text: 'Пополнение баланса' },
  	{ todo: 'Like User', text: 'Лайк пользователю' },
  	{ todo: 'Like Group', text: 'Лайк группе' },
  	{ todo: 'Opened User Like', text: 'Просмотр лайков' },
  	{ todo: 'Opened Group Like', text: 'Просмотр лайков' },
  	{ todo: 'Spin the Wheel', text: 'Крутить колесо' },
    { todo: 'Created Group', text: 'Создана группа' },
    { todo: 'Create', text: 'Создать' },
  	{ todo: 'Bonus Reward', text: 'Бонусная награда' },
    { todo: 'Paid', text: 'Пополнение баланса'},
  	{ todo: 'Spin Wheel', text: 'Колесо фортуны' },
  	{ todo: 'Transaction', text: 'Транзакция' },
  	{ todo: 'balance_top_up_header', text: 'Получите больше кристаллов' },
  	{ todo: 'coming_soon', text: 'Скоро будет доступно! 🚀' },
  	{ todo: 'balance_top_up_text', text: 'Совсем скоро вы сможете пополнять баланс, выбирая наборы с разным количеством кристаллов! 😊💎' },
   	{ todo: 'back', text: 'Назад' },
  	{ todo: 'confirm', text: 'Подтвердить' },
  	{ todo: 'setting_hidden_header', text: 'Скрыть профиль?' },
  	{ todo: 'setting_hidden_text', text: 'Если вы скроете профиль, он не будет отображаться в поиске или рекомендациях, и другие пользователи не смогут вас найти. Вы можете вернуть его видимость в любое время в настройках.' },
  	{ todo: 'setting_modal_logout', text: 'Выйти' },
  	{ todo: 'setting_modal_logout_header', text: 'Вы уверены, что хотите выйти?' },
  	{ todo: 'setting_modal_logout_text', text: 'Выход завершит текущую сессию, и вам нужно будет снова войти, чтобы получить доступ к профилю, чатам и балансу. Все ваши данные останутся в безопасности и будут доступны при следующем входе.' },
  	{ todo: 'setting_modal_delete', text: 'Удалить аккаунт' },
  	{ todo: 'setting_modal_delete_header', text: 'Вы уверены, что хотите удалить аккаунт?' },
  	{ todo: 'setting_modal_delete_text', text: 'Все ваши фото, чаты, лайки и взаимные лайки будут навсегда удалены, и другие пользователи больше не смогут вас найти. Также все ваши достижения и баланс будут аннулированы.' },
  	{ todo: 'loading', text: 'Загрузка ...' },
  	{ todo: 'load_more', text: 'Загрузить ещё' },
  	{ todo: 'empty_chat', text: 'Пустой чат' },
  	{ todo: 'massage_liked_me_header', text: 'Они вас лайкнули' },
  	{ todo: 'massage_liked_me_text', text: 'Похоже, тебя пока ещё никто не лайкнул. Но не переживай — возможно, твое просто ещё не нашло тебя 💌 Продолжай искать и дай судьбе немного времени!' },
  	{ todo: 'massage_liked_me_btn', text: 'Показать список' },
  	{ todo: 'massage_soulmates_header', text: 'Сообщения' },
  	{ todo: 'massage_soulmates_text', text: 'Пока нет взаимных лайков 💔 Продолжай искать — возможно, твое всего в одном свайпе от тебя! 💕' },
    { todo: 'match_user_looking', text: '🔮 Ищем твою вторую половинку... немного терпения 💕✨' },
    { todo: 'match_user_filters', text: 'Попробуй изменить фильтры, чтобы встретить ещё больше интересных людей 💫' },
    { todo: 'match_user_balance', text: 'Ваш баланс исчерпан. Пополните свои кристаллы, играя в Колесо Удачи или пополнив счёт. 💎🎡' },
    { todo: 'match_user_match', text: 'Это совпадение! 🥳' },
    { todo: 'match_user_go_to_chat', text: 'Перейти в чат!' },
    { todo: 'match_user_match_super_like', text: 'Супер Лайк!'},
    { todo: 'Super Like User', text: 'Супер лайк'},
    { todo: 'close', text: 'Закрыть' },
    { todo: 'details', text: 'Подробнее' },
    { todo: 'photos', text: 'Фото' },
    { todo: 'Interest', text: 'Интерес'},
    { todo: 'Christianity', text: 'Христианство'},
    { todo: 'Islam', text: 'Ислам'},
    { todo: 'Hinduism', text: 'Индуизм'},
    { todo: 'Buddhism', text: 'Буддизм'},
    { todo: 'Judaism', text: 'Иудаизм'},
    { todo: 'Sikhism', text: 'Сикхизм'},
    { todo: 'Atheism', text: 'Атеизм'},
    { todo: 'Agnosticism', text: 'Агностицизм'},
    { todo: 'Other', text: 'Другое'},
    { todo: 'Not Specified', text: 'Не указано'},
    { todo: 'Aries', text: 'Овен'},
    { todo: 'Taurus', text: 'Телец'},
    { todo: 'Gemini', text: 'Близнецы'},
    { todo: 'Cancer', text: 'Рак'},
    { todo: 'Leo', text: 'Лев'},
    { todo: 'Virgo', text: 'Дева'},
    { todo: 'Libra', text: 'Весы'},
    { todo: 'Scorpio', text: 'Скорпион'},
    { todo: 'Sagittarius', text: 'Стрелец'},
    { todo: 'Capricorn', text: 'Козерог'},
    { todo: 'Aquarius', text: 'Водолей'},
    { todo: 'Pisces', text: 'Рыбы'},
    { todo: 'liked_me', text: 'Лайки'},
    { todo: 'open_for', text: 'Открыть за'},
    { todo: 'likes_unlocked', text: 'Лайки открыты!'},
    { todo: 'likes_locked_text', text: 'Похоже, тебя ещё никто не лайкнул. Но не переживай — возможно, твоя родственная просто ещё не нашла тебя 💌 Продолжай искать и дай этому немного времени!'},
    { todo: 'open_likes_header', text: 'Подтверди оплату!'},
    { todo: 'open_likes_text', text: 'Подтверди оплату 1000 кристаллов, чтобы разблокировать список тех, кто лайкнул тебя, на 30 дней. После этого срока список снова станет недоступен.'},
    { todo: 'Delete', text: 'Удалить'},
    { todo: 'messages_empty', text: 'Привет! 😎 Скажи "Привет" и начни общение со своей! Погрузись в чат, улови настроение и позволь магии случиться! ✨'},
    { todo: 'messages_limit', text: 'Это количество твоих сообщений. 📩 После 20 сообщений чат закроется, и ты получишь доступ к профилю своей родственной в Telegram. 😊 Там вы сможете продолжить общение! 💬'},
    { todo: 'messages_limit_btn', text: 'Отлично, спасибо!'},
    { todo: 'cancel', text: 'Отмена'},
    { todo: 'messages_delete_header', text: 'Ты уверена, что хочешь удалить этот чат?'},
    { todo: 'messages_delete_text', text: 'Вся история переписки будет безвозвратно удалена, и этот контакт будет потерян. Подтверди своё решение.'},
    { todo: 'messages_placeholder', text: 'Напиши сообщение'},
    { todo: 'messages_btn_to_tg', text: 'Перейти в Telegram-чат'},
    { todo: 'messages_end_text', text: 'У одного из вас нет имени пользователя, поэтому в будущем вы не сможете перейти в Telegram-чат. 😕 Попроси ник заранее! 📩'},
    { todo: 'you', text: 'Вы'},
    { todo: 'group_coming_soon_text', text: 'В этом разделе ты сможешь создавать собственные события 🎉 или группы по интересам 👥, находить другие мероприятия 🌟 и приглашать друзей сходить вместе в театр 🎭, кафе ☕ и многое другое! 😄'},
    { todo: 'about_me', text: 'О мне'},
    { todo: 'i_find', text: 'Я ищу'},
    { todo: 'about_me_header', text: '✨ Настрой свой профиль и расскажи о себе, чтобы твоя вторая половинка смогла тебя найти ❤️'},
    { todo: 'placeholder_how_tall_are_you', text: 'Какой у тебя рост? (см)' },
    { todo: 'placeholder_career', text: 'Карьера' },
    { todo: 'placeholder_religion', text: 'Религия' },
    { todo: 'first_name', text: 'Имя' },
    { todo: 'last_name', text: 'Фамилия' },
    { todo: 'change_tags', text: 'Выбери несколько тегов, которые отражают то, что тебе нравится! Это поможет нам найти людей с похожими интересами.' },
    { todo: 'change_details', text: '✨ Заполни больше деталей, чтобы люди могли узнать тебя лучше ❤️😊' },
    { todo: 'edit', text: 'Эдит' },
    { todo: 'upload', text: 'Загрузить новое фото'},
    { todo: 'upload_browse', text: 'Выбрать фото'},
    { todo: 'i_find_header', text: 'Настрой фильтры 🔍 и найди свою вторую половинку 💖!' },
    { todo: 'placeholder_age', text: 'Восраст от/до?' },
    { todo: 'placeholder_before', text: 'Возраст от' },
    { todo: 'placeholder_to', text: 'до' },
    { todo: 'file_is_too_large', text: 'Файл слишком большой! Максимальный размер — 1 МБ.' },
    { todo: 'unsupported_file_type', text: 'Неподдерживаемый тип файла! Разрешены только JPG и PNG.' },
    { todo: 'no_face', text: 'Вы не выбрали фото для загрузки.' },
    { todo: 'selected_a_photo', text: 'На фото не обнаружено лица.' },
    { todo: 'mini_pack', text: 'Забери клисталы и зажги свой первый шаг!' },
    { todo: 'starter_pack', text: 'Начни свой путь с искристого буста кристаллов и открой новые возможности!' },
    { todo: 'booster_pack', text: 'Суперзаряди свой прогресс мощным всплеском кристаллов — поднимайся быстрее!' },
    { todo: 'power_pack', text: 'Высвободи мощный кристальный заряд, чтобы доминировать в игре и сиять ярче!' },
    { todo: 'mega_pack', text: 'Всё или ничего — колоссальный взрыв кристаллов: максимум наград и абсолютное превосходство!' },
    { todo: 'pay_alert', text: 'Проверь чат с ботом — там появилось окно оплаты ⭐'}
  ],
  en: [
  	...interestsListEN,
  	...relationshipOptions,
  	...findForOptions,
    ...serverTODO,
    ...groupsListEN,
  	{ todo: 'initData', text: 'Telegram data is missing'},
  	{ todo: 'error', text: 'Error'},
  	{ todo: 'error_other', text: 'An unknown error occurred, try changing the fields or refreshing the page'},
    { todo: 'auth_hello_header', text: 'Discover exciting events, vibrant communities, and the best channels — all in one place.' },
    { todo: 'auth_hello_sub', text: 'Your next adventure starts here!' },
    { todo: 'auth_hello_error_location', text: 'Location is disabled. Turn it on in Telegram app settings and try again.' },
    { todo: 'auth_hello_next_button', text: 'Find' },
    { todo: 'next', text: 'Next' },
    { todo: 'auth_hello_step2_header', text: '✨ Your love story starts here! ✨' },
    { todo: 'auth_hello_step2_sub', text: 'Before we dive into your adventure, let’s set up your profile. 💕' },
    { todo: 'gender_male', text: 'Male' },
  	{ todo: 'gender_female', text: 'Female' },
  	{ todo: 'gender_transgender', text: 'Transgender' },
  	{ todo: 'gender_other', text: 'Other' },
    { todo: 'gender_male', text: 'Male' },
    { todo: 'gender_female', text: 'Female' },
    { todo: 'gender_transgender', text: 'Transgender' },
    { todo: 'gender_other', text: 'Other' },
    { todo: 'gender_other', text: 'Other' },
    { todo: 'Male', text: 'Male' },
    { todo: 'Female', text: 'Female' },
    { todo: 'Transgender', text: 'Transgender' },
    { todo: 'Unknown', text: 'Other' },    
  	{ todo: 'placeholder_gender', text: 'Select your gender' },
  	{ todo: 'placeholder_gender_interest', text: 'Gender of interest' },
  	{ todo: 'auth_hello_step3_header', text: '🎯 What sparks your interest?' },
    { todo: 'auth_hello_step3_sub', text: 'Pick a few tags that describe what you love! This helps us connect you with like-minded people.' },
  	{ todo: 'auth_hello_step4_header', text: 'Define Your Connection 💫' },
    { todo: 'auth_hello_step4_sub', text: 'Let others know your relationship status and what you`re looking for. Whether it`s love, friendship, or just good company – choose what suits you best!' },
    { todo: 'placeholder_relationship', text: 'Relationship' },
  	{ todo: 'placeholder_looking_for', text: 'Looking for ... ' },
  	{ todo: 'auth_hello_step5_header', text: '🚀 Your Bio, Your Story' },
    { todo: 'auth_hello_step5_sub', text: 'Write something about yourself in one or two sentences. Keep it simple, keep it real.' },
    { todo: 'bio', text: 'Bio' },
    { todo: 'auth_hello_step6_header', text: 'Let’s Get to Know You! 🎭' },
    { todo: 'auth_hello_step6_sub', text: 'Your birth date help others connect with you. Be yourself and let the journey begin!' },
    { todo: 'auth_hello_step6_sub_sub', text: 'Age matters for a perfect match!' },
    { todo: 'day', text: 'Day' },
    { todo: 'month', text: 'Month' },
    { todo: 'year', text: 'Year' },
    { todo: 'auth_hello_step7_header', text: '🎉 All set! Let’s create your profile now!' },
    { todo: 'auth_hello_step7_btn', text: 'To profile' },
    { todo: 'spin_wheel_header', text: 'Spin the wheel every 12 hours 🎡, top up your balance and win extra crystals ✨!'},
    { todo: 'spin_wheel_btn', text: 'Spin the wheel' },
    { todo: 'spin_wheel_win_1', text: 'You’ve won'},
    { todo: 'spin_wheel_win_2', text: 'crystals!'},
    { todo: 'spin_wheel_win_text', text: 'Come back in 12 hours and try your luck again—you might hit the jackpot next time! 🎰'},
    { todo: 'spin_wheel_win_claim_1', text: 'Claim'},
    { todo: 'spin_wheel_win_claim_3', text: 'crystal'},
    { todo: 'spin_wheel_win_time_1', text: 'Come back on'}, 
    { todo: 'spin_wheel_win_time_2', text: 'and try your luck again — you might hit the jackpot next time! 😎'},
    { todo: 'spin_wheel_ok', text: 'Ok, thank!'},
    { todo: 'spin_wheel_title', text: 'You cannot play a game!' },
    { todo: 'global_search', text: 'Global search'},
    { todo: 'Profile', text: 'Profile'},
    { todo: 'Balance', text: 'Balance'},
    { todo: 'Settings', text: 'Settings'},
    { todo: 'balance', text: 'Crystal balance'},
    { todo: 'balance_top_up', text: 'Top Up'},
    { todo: 'balance_activity', text: 'Last activity'},
    { todo: 'balance_header', text: '🚀 Boost Your Social Reach with Token Power!'},
    { todo: 'balance_text', text: 'All premium features are always available to enhance your experience! Simply use your token balance to activate options like creating more groups, boosting daily likes — no monthly subscription required!'},
    { todo: 'Balance Refill', text: 'Balance Refill'},
    { todo: 'Like User', text: 'Like User'},
    { todo: 'Super Like User', text: 'Super Like User'},
    { todo: 'Like Group', text: 'Like Group'},
    { todo: 'Opened User Like', text: 'Opened User Like'},
    { todo: 'Opened Group Like', text: 'Opened Group Like'},
    { todo: 'Spin the Wheel', text: 'Spin the Wheel'},
    { todo: 'Created Group', text: 'Created group' },
    { todo: 'Create', text: 'Create' },
    { todo: 'Bonus Reward', text: 'Bonus Reward'},
    { todo: 'Paid', text: 'Balance top-up'},
    { todo: 'Spin Wheel', text: 'Spin Wheel'},
    { todo: 'Transaction', text: 'Transaction'},
    { todo: 'balance_top_up_header', text: 'Get more Crystals'},
    { todo: 'coming_soon', text: 'Coming Soon! 🚀'},
    { todo: 'balance_top_up_text', text: 'Soon, you’ll be able to top up your balance by choosing packs with different amounts of crystals! 😊💎'},
    { todo: 'back', text: 'Back'},
    { todo: 'confirm', text: 'Confirm'},
    { todo: 'setting_hidden_header', text: 'Hide Your Profile?'},
    { todo: 'setting_hidden_text', text: 'When hidden, your profile won`t appear in searches or recommendations and other users won`t be able to find you. You can unhide it anytime in settings.'},
    { todo: 'setting_modal_logout', text: 'Logout'},
    { todo: 'setting_modal_logout_header', text: 'Are you sure you want to log out?'},
    { todo: 'setting_modal_logout_text', text: 'Logging out will end your current session, and you’ll need to sign in again to access your profile, chats, and balance. Your data will remain safe and accessible upon your return.'},
    { todo: 'setting_modal_delete', text: 'Delete account'},
    { todo: 'setting_modal_delete_header', text: 'Are you sure you want to delete your account?'},
    { todo: 'setting_modal_delete_text', text: 'All your photos, chats, likes, and mutual likes will be permanently removed, and others will no longer be able to find you. Additionally, all your balance achievements will be canceled.'},
  	{ todo: 'loading', text: 'Loading ...'},
  	{ todo: 'load_more', text: 'Load More'},
  	{ todo: 'empty_chat', text: 'Empty chat'},
  	{ todo: 'massage_liked_me_header', text: 'They like you'},
  	{ todo: 'massage_liked_me_text', text: 'Looks like no one has liked you yet. But don’t worry — maybe your just hasn’t discovered you 💌 Keep exploring and give it a little time!'},
  	{ todo: 'massage_liked_me_btn', text: 'Show list'},
  	{ todo: 'massage_soulmates_header', text: 'Events'},
  	{ todo: 'massage_soulmates_text', text: 'No mutual likes yet 💔 Keep exploring — your might be just one swipe away! 💕'},
    { todo: 'match_user_looking', text: '🔮 Looking for your... hang tight 💕✨'},
    { todo: 'match_user_filters', text: 'Try adjusting your filters to discover more amazing people 💫'},
    { todo: 'match_user_balance', text: 'Your balance has run out. Replenish your crystals by playing Spin Wheel or top up your account. 💎🎡'},
    { todo: 'match_user_match', text: 'It`s a match! 🥳'},
    { todo: 'match_user_go_to_chat', text: 'Go to chat!'},
    { todo: 'match_user_match_super_like', text: 'Super Like!'},
    { todo: 'close', text: 'Close'},
    { todo: 'details', text: 'Details'},
    { todo: 'photos', text: 'Photos'},
    { todo: 'Interest', text: 'Interest'},
    { todo: 'Christianity', text: 'Christianity'},
    { todo: 'Islam', text: 'Islam'},
    { todo: 'Hinduism', text: 'Hinduism'},
    { todo: 'Buddhism', text: 'Buddhism'},
    { todo: 'Judaism', text: 'Judaism'},
    { todo: 'Sikhism', text: 'Sikhism'},
    { todo: 'Atheism', text: 'Atheism'},
    { todo: 'Agnosticism', text: 'Agnosticism'},
    { todo: 'Other', text: 'Other'},
    { todo: 'Not Specified', text: 'Not specified'},
    { todo: 'Aries', text: 'Aries'},
    { todo: 'Taurus', text: 'Taurus'},
    { todo: 'Gemini', text: 'Gemini'},
    { todo: 'Cancer', text: 'Cancer'},
    { todo: 'Leo', text: 'Leo'},
    { todo: 'Virgo', text: 'Virgo'},
    { todo: 'Libra', text: 'Libra'},
    { todo: 'Scorpio', text: 'Scorpio'},
    { todo: 'Sagittarius', text: 'Sagittarius'},
    { todo: 'Capricorn', text: 'Capricorn'},
    { todo: 'Aquarius', text: 'Aquarius'},
    { todo: 'Pisces', text: 'Pisces'},
    { todo: 'liked_me', text: 'Liked Me'},
    { todo: 'open_for', text: 'Open For'},
    { todo: 'likes_unlocked', text: 'Likes Unlocked!'},
    { todo: 'likes_locked_text', text: 'Looks like no one has liked you yet. But don’t worry — maybe your just hasn’t discovered you 💌 Keep exploring and give it a little time!'},
    { todo: 'open_likes_header', text: 'Confirm the payment!'},
    { todo: 'open_likes_text', text: 'Confirm the payment of 1000 crystals to unlock who liked you for 30 days. After 30 days, the list will become unavailable again.'},
    { todo: 'Delete', text: 'Delete'},
    { todo: 'messages_empty', text: 'Hey there! 😎 Say "Hi" and spark a connection with your! Dive into the chat, share a vibe, and let the magic happen! ✨'},
    { todo: 'messages_limit', text: 'This is the number of your messages. 📩 After 20 messages, the chat will close, and you will gain access to your profile on Telegram. 😊 You can continue chatting there! 💬'},
    { todo: 'messages_limit_btn', text: 'Great, Thanks!'},
    { todo: 'cancel', text: 'Cancel'},
    { todo: 'messages_delete_header', text: 'Are you sure you want to delete this chat?'},
    { todo: 'messages_delete_text', text: 'All your conversation history will be permanently deleted, and this contact will be lost. Please confirm your decision.'},
    { todo: 'messages_placeholder', text: 'Write a message'},
    { todo: 'messages_btn_to_tg', text: 'Go to the Telegram Chat'},
    { todo: 'messages_end_text', text: 'One of you doesn`t have a username, so one of you won`t be able to move to the Telegram chat in the future. 😕 Ask for their nickname in advance! 📩'},
    { todo: 'you', text: 'You'},
    { todo: 'group_coming_soon_text', text: 'In this section, you’ll be able to create your own events 🎉 or interest-based groups 👥, discover other events 🌟, and find friends to join you for theater 🎭, café visits ☕, and more! 😄'},
    { todo: 'about_me', text: 'About Me'},
    { todo: 'i_find', text: 'I find'},
    { todo: 'about_me_header', text: '✨ Set up your profile & share your details so your can find you ❤️'},
    { todo: 'placeholder_how_tall_are_you', text: 'How tall are you? (cm)' },
    { todo: 'placeholder_career', text: 'Your career' },
    { todo: 'placeholder_religion', text: 'Your religion' },
    { todo: 'first_name', text: 'First name' },
    { todo: 'last_name', text: 'Last name' },
    { todo: 'change_tags', text: 'Pick a few tags that describe what you love! This helps us connect you with like-minded people.' },
    { todo: 'change_details', text: '✨ Fill in more details so people can get to know you better ❤️😊'},
    { todo: 'edit', text: 'Edit'},
    { todo: 'upload', text: 'Upload new photo'},
    { todo: 'upload_browse', text: 'Browse your file'},
    { todo: 'i_find_header', text: 'Set up filters 🔍 and find your 💖!'},
    { todo: 'placeholder_age', text: 'Age from to?' },
    { todo: 'placeholder_before', text: 'Age from' },
    { todo: 'placeholder_to', text: 'to' },
    { todo: 'file_is_too_large', text: 'File is too large! Maximum size is 1 MB.'}, 
    { todo: 'unsupported_file_type', text: 'Unsupported file type! Only JPG and PNG are allowed.'}, 
    { todo: 'selected_a_photo', text: 'You haven`t selected a photo to upload.'},
    { todo: 'no_face', text: 'No face detected in the photo'},
    { todo: 'mini_pack', text: 'Grab a crystals and light up your first step!'},
    { todo: 'starter_pack', text: 'Kickstart your journey with a sparkling crystal boost and unlock new possibilities!'},
    { todo: 'booster_pack', text: 'Supercharge your progress with an extra crystal surge—level up faster!'},
    { todo: 'power_pack', text: 'Unleash a massive crystal power-up to dominate the game and shine brighter!'},
    { todo: 'mega_pack', text: 'Go all-in with a colossal crystal explosion—maximize your rewards and reign supreme!'},
    { todo: 'pay_alert', text: 'Check the chat with the bot — a payment window has appeared there! ⭐'}
  ],
};

export const textLang = (todo) => {
  const lang = localStorage.getItem('lang') || 'en';
  const currentList = listTodo[lang] || listTodo.en;

  const found = currentList.find(item => item.todo === todo);
  return found ? found.text : todo; 
};